import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { useDateFormatter } from '@mint-lib/formatting-hooks';
import { useTranslation } from '@mint-lib/i18n';
import { parseISO } from 'date-fns';

import { getFormattedValue } from '../../../utils/getFormattedValue.jsx';

const DateRenderer = (params: CustomCellRendererProps) => {
  const { t } = useTranslation('@myn/planning_v2');

  const dateFormatter = useDateFormatter();
  const formatterFn = () => {
    return dateFormatter.formatDate(parseISO(params.value));
  };

  const formattedValue = getFormattedValue(params, {
    formatterFn,
    placeholderText: t('Select'),
  });

  return formattedValue;
};

export default DateRenderer;
